import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api } from "@/lib/apiClient";
import { setPageMeta, htmlToText } from "@/lib/seo";
import { QrCode, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function Page() {
  const { slug } = useParams();
  const [page, setPage] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    setPage(null); setNotFound(false);
    api.getPage(slug).then(setPage).catch(() => setNotFound(true));
  }, [slug]);

  useEffect(() => {
    if (page) setPageMeta({
      title: `${page.title} — DynaQR`,
      description: htmlToText(page.content),
      canonical: `${window.location.origin}/page/${slug}`,
    });
  }, [page, slug]);

  return (
    <div className="min-h-screen bg-background">
      <header className="border-b border-border">
        <div className="mx-auto max-w-4xl px-4 sm:px-6 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2.5">
            <div className="grid h-9 w-9 place-items-center rounded-xl bg-accent text-accent-foreground"><QrCode className="h-5 w-5" /></div>
            <span className="font-display text-xl font-extrabold tracking-tighter">DynaQR</span>
          </Link>
          <Link to="/signup"><Button className="rounded-full" size="sm">Get Started</Button></Link>
        </div>
      </header>
      <main className="mx-auto max-w-4xl px-4 sm:px-6 py-12" data-testid="usecase-page">
        {notFound ? <p className="text-muted-foreground">Page not found.</p>
          : !page ? <Loader2 className="h-6 w-6 animate-spin text-accent" />
          : (
            <>
              <h1 className="font-display text-4xl font-extrabold tracking-tighter mb-6">{page.title}</h1>
              <div className="policy-content text-base leading-relaxed text-foreground/90 space-y-4"
                dangerouslySetInnerHTML={{ __html: page.content }} />
              <div className="mt-10 rounded-2xl border-2 border-accent bg-card p-6 text-center glow-green">
                <p className="font-display text-xl font-bold">Ready to try DynaQR?</p>
                <p className="text-sm text-muted-foreground mt-1">One QR. Every occasion. ₹499/year.</p>
                <Link to="/signup"><Button className="mt-4 rounded-full">Get Started</Button></Link>
              </div>
            </>
          )}
      </main>
    </div>
  );
}
